import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import { LIGHT_SENSOR } from '../../../../../../utils/constantFeatures';
import PropertySwitch from './components/PropertySwitch';
import PropertyPicker from './components/PropertyPicker';
import { Trans } from 'react-i18next';

class LightSensor extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[LIGHT_SENSOR.enable].value === "1" ? true : false
        };

        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };

        this.props.handleChange(propertyName, v);

        if (this.getCorrectPropertyName(propertyName) === LIGHT_SENSOR.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }
    }

    render() {
        const lscEn = this.props.properties[LIGHT_SENSOR.enable];
        const lscOnV = this.props.properties[LIGHT_SENSOR.onVoltage];
        const lscOffV = this.props.properties[LIGHT_SENSOR.offVoltage];
        const lscOnL = this.props.properties[LIGHT_SENSOR.onLevel];
        const lscOffL = this.props.properties[LIGHT_SENSOR.offLevel];
        const lscDT = this.props.properties[LIGHT_SENSOR.detectionTime];

        return (
            <><Row>
                <Col lg={4} md={6} sm={12}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            {this.props.feature.displayName}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                            <PropertySwitch
                                property={lscEn}
                                title={lscEn.info.displayName}
                                handleChange={this.handleChange} />

                            <Row className="unit-measure-current-setting" style={{ paddingTop: '0.75rem'}}>
                                <Col></Col>
                                <Col>{<Trans i18nKey="Off_Low" />}</Col>
                                <Col>{<Trans i18nKey="On_High" />}</Col>
                            </Row>
                            <Row className="unit-measure-current-setting" style={{ paddingTop: '0.75rem'}}>
                                <Col className="d-flex align-items-center">{<Trans i18nKey="Detect" />}</Col>
                                <Col>
                                    <PropertyPicker
                                        disabled={!this.state.isEnabled}
                                        property={lscOnV}
                                        inputPadding={'padding-none'}
                                        measureUnit={lscOnV.info.unit}
                                        min={lscOnV.valueMeta.min}
                                        max={lscOnV.valueMeta.max}
                                        step={0.1}
                                        handleChange={this.handleChange} />
                                </Col>
                                <Col>
                                    <PropertyPicker
                                        disabled={!this.state.isEnabled}
                                        property={lscOffV}
                                        inputPadding={'padding-none'}
                                        measureUnit={lscOffV.info.unit}
                                        min={lscOffV.valueMeta.min}
                                        max={lscOffV.valueMeta.max}
                                        step={0.1}
                                        handleChange={this.handleChange} />
                                </Col>
                            </Row>
                            <Row className="unit-measure-current-setting" style={{ paddingTop: '0.75rem'}}>
                                <Col className="d-flex align-items-center">{<Trans i18nKey="Output_Level" />}</Col>
                                <Col>
                                    <PropertyPicker
                                        disabled={!this.state.isEnabled}
                                        property={lscOnL}
                                        inputPadding={'padding-none'}
                                        measureUnit={lscOnL.info.unit}
                                        min={lscOnL.valueMeta.min}
                                        max={lscOnL.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                </Col>
                                <Col>
                                    <PropertyPicker
                                        disabled={!this.state.isEnabled}
                                        property={lscOffL}
                                        inputPadding={'padding-none'}
                                        measureUnit={lscOffL.info.unit}
                                        min={lscOffL.valueMeta.min}
                                        max={lscOffL.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                </Col>
                            </Row>
                            <Row className="unit-measure-current-setting" style={{ paddingTop: '0.75rem'}}>
                                <Col className="d-flex align-items-center">{lscDT.info.displayName}</Col>
                                <Col>
                                    <PropertyPicker
                                        disabled={!this.state.isEnabled}
                                        property={lscDT}
                                        inputPadding={'padding-none'}
                                        measureUnit={lscDT.info.unit}
                                        min={lscDT.valueMeta.min}
                                        max={lscDT.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                </Col>
                                <Col></Col>
                            </Row>

                        </Card.Body>
                    </Card>
                </Col>
            </Row></>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(LightSensor);
